import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
import { legacyHashSchema } from './legacy-document.js';
export const LEXWARE_ARCHIVE_MAX_BYTES = 20 * 1024 ** 3;
export const LEXWARE_ARCHIVE_CHUNK_BYTES = 8 * 1024 * 1024;
export const lexwareArchiveUploadStatusSchema = z.enum([
    'UPLOADING',
    'QUEUED',
    'EXTRACTING',
    'PREVIEW_READY',
    'IMPORTING',
    'COMPLETED',
    'FAILED',
]);
export const lexwareArchiveErrorCodeSchema = z.enum([
    'ARCHIVE_INVALID',
    'EXTRACTION_FAILED',
    'IMPORT_FAILED',
    'PERMISSION_REVOKED',
    'STORAGE_UNAVAILABLE',
]);
const count = z.number().int().nonnegative();
export const lexwareArchiveExtractionSummarySchema = z
    .object({
    sourceTenants: z.array(z.object({ key: z.string().min(1).max(255), documentCount: count }).strict()),
    textDocuments: count,
    imageOnlyDocuments: count,
    textErrors: count,
    truncatedDocuments: count,
    ignoredXortFiles: count,
    excludedFiles: count,
    unclassifiedDocuments: count,
    documentsWithCustomerNumber: count,
    documentsWithDocumentNumber: count,
})
    .strict();
export const lexwareArchiveUploadCreateSchema = z
    .object({
    fileName: z
        .string()
        .min(5)
        .max(255)
        .regex(/^[^/\\]+\.zip$/iu)
        .refine((value) => Array.from(value).every((character) => {
        const point = character.codePointAt(0) ?? 0;
        return point >= 32 && point !== 127;
    })),
    fileSize: z.number().int().min(1).max(LEXWARE_ARCHIVE_MAX_BYTES),
    fileFingerprint: legacyHashSchema,
})
    .strict();
export const lexwareArchiveChunkQuerySchema = z
    .object({
    offset: z.coerce.number().int().min(0).max(LEXWARE_ARCHIVE_MAX_BYTES),
    sha256: legacyHashSchema,
})
    .strict();
export const lexwareArchiveConfirmSchema = z.object({ previewHash: legacyHashSchema }).strict();
export const lexwareArchiveRetrySchema = z
    .object({ previewHash: legacyHashSchema.optional() })
    .strict();
export const lexwareArchiveUploadSchema = z
    .object({
    id: idSchema,
    fileName: z.string(),
    fileSize: z.number().int().min(1).max(LEXWARE_ARCHIVE_MAX_BYTES),
    fileFingerprint: legacyHashSchema,
    receivedBytes: count.max(LEXWARE_ARCHIVE_MAX_BYTES),
    status: lexwareArchiveUploadStatusSchema,
    archiveSha256: legacyHashSchema.nullable(),
    previewHash: legacyHashSchema.nullable(),
    totalDocuments: count,
    importedDocuments: count,
    summaryJson: lexwareArchiveExtractionSummarySchema.nullable(),
    errorCode: lexwareArchiveErrorCodeSchema.nullable(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
})
    .strict();
export const lexwareArchiveUploadListSchema = z
    .object({ data: z.array(lexwareArchiveUploadSchema) })
    .strict();
export const lexwareArchiveProgressSchema = z
    .object({
    status: lexwareArchiveUploadStatusSchema.optional(),
    archiveSha256: legacyHashSchema.nullable().optional(),
    indexSha256: legacyHashSchema.nullable().optional(),
    totalDocuments: count.optional(),
    importedDocuments: count.optional(),
    summaryJson: lexwareArchiveExtractionSummarySchema.nullable().optional(),
    errorCode: lexwareArchiveErrorCodeSchema.nullable().optional(),
})
    .strict();
//# sourceMappingURL=lexware-archive-upload.js.map